import {RouterView} from '../RouterView.js';
import Index from '@/components/views/administration/settings/templates/Index.vue';
import HeaderFooter from '@/components/views/administration/settings/templates/partials/HeaderFooter.vue';
// import Configuration from '@/components/views/administration/settings/templates/partials/Configuration.vue';

const Configuration = _ => import(/* webpackChunkName: "js/split/Configuration", webpackPreload: true */ '@/components/views/administration/settings/templates/partials/Configuration.vue');


export default {
    path: 'plantillas',
    component: RouterView,
    children: [
        {
            path: '',
            component: Index,
            meta:{
                auth: true
            }
        },
        {
            path: 'configuracion',
            component: Configuration,
            params: true,
            name:'configuracion-de-plantilla',
            meta:{
                auth: true
            }
        },
        {
            path: 'header-footer',
            component: HeaderFooter,
            meta:{
                auth: true
            }
        },
    ]
}
